import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';
import FloatingBubbles from './FloatingBubbles';

const FeaturesSection = () => {
  const { language } = useLanguage();
  
  const features = [
    {
      id: 2,
      title: getTranslation(language, 'feature2Title'),
      description: getTranslation(language, 'feature2Desc'),
      image: 'https://images.unsplash.com/photo-1581092583537-20d51b4b4f1b?w=600&q=80'
    },
    {
      id: 3,
      title: getTranslation(language, 'feature3Title'),
      description: getTranslation(language, 'feature3Desc'),
      image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&q=80'
    },
    {
      id: 4,
      title: getTranslation(language, 'feature4Title'),
      description: getTranslation(language, 'feature4Desc'),
      image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_construction-global/artifacts/65cfde854113cb44_WhatsApp%20Image%202026-10-18%20at%2018.25.05.jpeg'
    }
  ];
  
  return (
    <section className="py-12 bg-white relative overflow-hidden">
      <FloatingBubbles count={12} />
      <div className="max-w-[1800px] mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-3" style={{ color: '#702963' }}>
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;